export const SET_ASSIGNMENT_REFERENCE = (state, value) => {
  state.assignmentReference = value
}
